export default "__VITE_ASSET__Cp00EJ0p__"